export default {
  path: '/badges',
  name: 'badges',
  component: () => import('../components/badge/Layout'),
  redirect: { name: 'BadgeList' },
  meta: {
    breadcrumb: 'badges',
  },
  children: [
    {
      name: 'BadgeList',
      path: '',
      component: () => import('../views/badge/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'BadgeCreate',
      path: 'new',
      component: () => import('../views/badge/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'BadgeUpdate',
      path: ':id/edit',
      component: () => import('../views/badge/Update'),
      meta: {
        breadcrumb: 'badge',
      },
    },
    {
      name: 'BadgeShow',
      path: ':id',
      component: () => import('../views/badge/Show'),
      meta: {
        breadcrumb: 'badge',
      },
    }
  ]
};
